import { sortFunction } from "components/MainSearch/Functions";
import { Tab } from "../Types";
import { CreditorSearchResult } from "reducers/GlobalSearch/Types";

/**
 * @function
 * @description To get the creditor search results sorted
 * @param creditorDetails Filtered Creditor search results
 * @param tabInfo Formik tab information
 * @returns sorted input
 */
export const getCreditorValSorted = (
  creditorDetails: CreditorSearchResult[],
  { sortKey, sortOrder }: Tab<CreditorSearchResult>
) => {
  try {
    if (Array.isArray(creditorDetails)) {
      return creditorDetails.sort((value1, value2) =>
        sortFunction(
          value1[sortKey as keyof CreditorSearchResult],
          value2[sortKey as keyof CreditorSearchResult],
          sortOrder
        )
      );
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};
